<template>
  <div class="">
    <div
      v-if="title !== ''"
      class="px-6 pb-1.5"
      :class="titleClass"
    >
      <slot name="title">
        {{ title }}
      </slot>
    </div>
    <div
      :class="[ border || title !== '' ? 'border-t border-stone-100' : '', grid ? 'grid  gap-x-3 gap-y-4 m-0 p-0' : '', margin ? 'pt-3' : 'not-first:mt-6', grid ? gridCols : '']"
      class="px-6 mb-6 last:mb-6 "
    >
      <slot />
    </div>
  </div>
</template>
<script setup>
import { useProp } from '@/composables/useProp.js'
import { computed } from 'vue'

const props = defineProps({
  border: useProp(Boolean),
  grid: useProp(Boolean, true),
  margin: useProp(Boolean, true),
  title: useProp(String),
  titleClass: useProp(String, 'font-medium text-base text-black uppercase'),
  gridCols: useProp(Number, 24)
})

const gridCols = computed(() => `grid-cols-${props.gridCols}`)

</script>
